import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BrandProvider } from "@/context/BrandContext";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <BrowserRouter>
      <BrandProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dales" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Toaster />
      </BrandProvider>
    </BrowserRouter>
  );
}

export default App;
